module.exports = __webpack_public_path__ + "img/LT304862948.9b95dd80.png";